import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo";
import { serviceLd, faqLd, breadcrumbLd } from "@/lib/ld/epr";

export const Route = createFileRoute("/_app/epr")({
  head: () =>
    buildHead({
      title: "EPR Credit Brokerage India — Plastic, E-Waste & Battery | LohaLink",
      description:
        "EPR compliance made simple: buy verified plastic waste, e-waste, battery, tyre and used oil EPR credits from CPCB-registered recyclers. Escrow-protected, audit-ready, pan-India.",
      canonical: "/epr",
      jsonLd: [serviceLd, faqLd, breadcrumbLd],
    }),
  component: lazyRouteComponent(() => import("@/pages/EPR")),
});
